import createReactComponent from '../createReactComponent';
var Tent = createReactComponent('Tent', [['path', {
  d: 'M19 20L10 4',
  key: '57vubo'
}], ['path', {
  d: 'M5 20l9-16',
  key: 'bd3zzz'
}], ['path', {
  d: 'M3 20h18',
  key: '1l19wn'
}], ['path', {
  d: 'M12 15l-3 5',
  key: 'x80k7'
}], ['path', {
  d: 'M12 15l3 5',
  key: '1jzjxq'
}]]);
export default Tent;